import React, { useRef } from 'react';
import ProcessingState from '@/Models/ProcessingState';
import UIStrings from '@/Utils/UIStrings';
import Page from '@/Pages/Page';
import PageContentLoading from '../../../PageContentLoading';
import ModifyRecruitmentStepper from '../Components/ModifyRecruitmentStepper';
import { ModifyRecruitmentStepMapper } from '../Components/StepMappers';
import { useEditRecruitmentContext } from './Contexts/EditRecruitmentContext';
import { useAssessmentSettings } from '@/api/useAssessmentSettings';
import TopBar from '@/Components/TopBars/TopBar';

const EditRecruitmentPageContent = () => {
    const { processingState, gettingDataProcessingState, includesExperienceCriteria } = useEditRecruitmentContext();
    const { isLoading: isAssessmentSettingsLoading } = useAssessmentSettings();
    const pageContentContainerRef = useRef<HTMLDivElement>(null);
    const isLoading = gettingDataProcessingState === ProcessingState.Processing || isAssessmentSettingsLoading;
    const steps = [UIStrings.JobDetails, UIStrings.JobDescription];

    if (includesExperienceCriteria) {
        steps.push(UIStrings.IdentifyExperience);
    }

    return (
        <Page
            topBar={<TopBar onlyLogo />}
            pageContainerProps={{ className: 'h-screen' }}
            pageContentContainerProps={{
                className: 'relative grow',
                style: {},
                ref: pageContentContainerRef,
            }}
        >
            <PageContentLoading
                isLoading={isLoading}
                loadingFailed={
                    // the && operator is significant here because we want to redirect to the error page if
                    // its on the loading process, and not when something went wrong on submission and that a backend
                    // throw would trigger this line and make any efforts to popup a fail toaster while staying
                    // on the page to be impossible
                    processingState === ProcessingState.Error && gettingDataProcessingState === ProcessingState.Error
                }
            >
                <ModifyRecruitmentStepper
                    steps={steps}
                    stepMapper={ModifyRecruitmentStepMapper}
                    containerRef={pageContentContainerRef}
                />
            </PageContentLoading>
        </Page>
    );
};

export default EditRecruitmentPageContent;
